module.exports = __webpack_public_path__ + "img/completed.32edc7af.png";